<template>
  <router-view />
</template>

<style >
html,body{
  background: #eeeeee;

}
#app {
  color: #2c3e50;
  background: #eeeeee;
  padding: 30px 0;
  font-family: 'Times';
  box-sizing: border-box;
  height: auto !important;

}
* {
  margin: 0;
  padding: 0;
}

</style>
